import { Injectable } from "@angular/core";
import {
  Response,
  RequestOptions,
  ResponseContentType,
  Http,
} from "@angular/http";
import { Observable } from "rxjs/Observable";
import { WebService } from "../web.service";
import { map } from "rxjs/operators";

@Injectable()
export class CandidateService extends WebService {
  public getCandidate(
    page?: number,
    per_page?: number,
    sort?: string,
    query?: string,
    filters?: any[],
    _with?: string,
    _with_count?: string
  ): Observable<Response> {
    let params: URLSearchParams = new URLSearchParams();

    if (page !== null && page !== undefined) {
      params.append("_page", String(page));
    } else {
      params.append("_page", "1");
    }

    if (per_page !== null && per_page !== undefined) {
      params.append("_limit", String(per_page));
    } else {
      params.append("_limit", "10");
    }

    if (sort !== null && sort !== undefined) {
      params.append("_sort", String(sort));
    }

    if (query !== null && query !== undefined && query !== "") {
      params.append("_q", String(query));
    }

    if (filters !== null && filters !== undefined && filters.length > 0) {
      filters.forEach((element) => {
        params.append(element.key, String(element.value));
      });
    }

    if (_with !== null && _with !== undefined) {
      params.append("_with", _with);
    }
    if (_with_count !== null && _with_count !== undefined) {
      params.append("_with_count", _with_count);
    }

    const options = new RequestOptions({
      search: params,
      headers: this.headers,
    });

    return this.http.get(`${this.apiUrl}/candidates?${params}`, options);
  }

  public getCandidateByEducation(
    page?: number,
    per_page?: number,
    sort?: string,
    query?: string,
    filters?: any[]
  ): Observable<Response> {
    let params: URLSearchParams = new URLSearchParams();

    if (page !== null && page !== undefined) {
      params.append("_page", String(page));
    } else {
      params.append("_page", "1");
    }

    if (per_page !== null && per_page !== undefined) {
      params.append("_limit", String(per_page));
    } else {
      params.append("_limit", "10");
    }

    if (sort !== null && sort !== undefined) {
      params.append("_sort", String(sort));
    }

    if (query !== null && query !== undefined && query !== "") {
      params.append("_q", String(query));
    }

    if (filters !== null && filters !== undefined && filters.length > 0) {
      filters.forEach((element) => {
        params.append(element.key, String(element.value));
      });
    }

    params.append(
      "_with",
      String(
        "candidate.education,candidate.work_experience,candidate.candidate_comment"
      )
    );

    const options = new RequestOptions({
      search: params,
      headers: this.headers,
    });

    return this.http.get(`${this.apiUrl}/candidates-search?${params}`, options);
  }

  public getCandidateByWorkExperience(
    page?: number,
    per_page?: number,
    sort?: string,
    query?: string,
    filters?: any[]
  ): Observable<Response> {
    let params: URLSearchParams = new URLSearchParams();

    if (page !== null && page !== undefined) {
      params.append("_page", String(page));
    } else {
      params.append("_page", "1");
    }

    if (per_page !== null && per_page !== undefined) {
      params.append("_limit", String(per_page));
    } else {
      params.append("_limit", "10");
    }

    if (sort !== null && sort !== undefined) {
      params.append("_sort", String(sort));
    }

    if (query !== null && query !== undefined && query !== "") {
      params.append("_q", String(query));
    }

    if (filters !== null && filters !== undefined && filters.length > 0) {
      filters.forEach((element) => {
        params.append(element.key, String(element.value));
      });
    }

    params.append(
      "_with",
      String(
        "candidate.education,candidate.work_experience,candidate.candidate_comment"
      )
    );

    const options = new RequestOptions({
      search: params,
      headers: this.headers,
    });

    return this.http.get(`${this.apiUrl}/candidates-search?${params}`, options);
  }
  public getCandidateLow(
    page?: number,
    per_page?: number,
    sort?: string,
    query?: string,
    filters?: any[],
    _with?: string
  ): Observable<Response> {
    let params: URLSearchParams = new URLSearchParams();

    if (page !== null && page !== undefined) {
      params.append("_page", String(page));
    } else {
      params.append("_page", "1");
    }

    if (per_page !== null && per_page !== undefined) {
      params.append("_limit", String(per_page));
    } else {
      params.append("_limit", "10");
    }

    if (sort !== null && sort !== undefined) {
      params.append("_sort", String(sort));
    }

    if (query !== null && query !== undefined && query !== "") {
      params.append("_q", String(query));
    }

    if (filters !== null && filters !== undefined && filters.length > 0) {
      filters.forEach((element) => {
        params.append(element.key, String(element.value));
      });
    }

    if (_with !== null && _with !== undefined) {
      params.append("_with", _with);
    }

    const options = new RequestOptions({
      search: params,
      headers: this.headers,
    });

    return this.http.get(`${this.apiUrl}/candidates-low?${params}`, options);
  }

  public newCandidate(body: Object): Observable<Response> {
    return this.http.post(`${this.apiUrl}/candidates`, JSON.stringify(body), {
      headers: this.headers,
    });
  }

  public updateCandidate(id: number, body: Object): Observable<Response> {
    return this.http.patch(
      `${this.apiUrl}/candidates/${id}`,
      JSON.stringify(body),
      { headers: this.headers }
    );
  }

  public deleteCandidate(id: number): Observable<Response> {
    return this.http.delete(`${this.apiUrl}/candidates/${id}`, {
      headers: this.headers,
    });
  }

  public viewCandidate(id: number): Observable<Response> {
    let params: URLSearchParams = new URLSearchParams();
    params.append(
      "_with",
      String(
        "citation.document_profile_survey,citation.requisition_candidate.company,citation.requisition_candidate.profile_survey,citation.requisition_candidate.venue"
      )
    );
    return this.http.get(`${this.apiUrl}/candidates/${id}?${params}`, {
      headers: this.headers,
    });
  }
  public infoCandidate(id: number): Observable<Response> {
    let params: URLSearchParams = new URLSearchParams();
    params.append(
      "_with",
      String("created_by,contacts_candidate,work_experience")
    );
    return this.http.get(`${this.apiUrl}/candidates/${id}?${params}`, {
      headers: this.headers,
    });
  }

  public infoCandidateRelations(id: number): Observable<Response> {
    let params: URLSearchParams = new URLSearchParams();
    params.append(
      "_with",
      String(
        "created_by,height,profession_r,residence_country_r,residence_department_r,residence_city_r,birth_country_r,birth_department_r,birth_city_r,expedition_city_r"
      )
    );
    return this.http.get(`${this.apiUrl}/candidates/${id}?${params}`, {
      headers: this.headers,
    });
  }

  public infoCandidateSmall(id: number): Observable<Response> {
    return this.http.get(`${this.apiUrl}/candidates/${id}?`, {
      headers: this.headers,
    });
  }

  public getDocumentHV(id: number): Observable<Response> {
    return this.http.get(`${this.apiUrl}/hojasdevidas/${id}/files`, {
      headers: this.headers,
    });
  }

  public sorttimeCandidate(body: Object): Observable<Response> {
    return this.http.post(
      `${this.apiUrl}/candidates-sorttime`,
      JSON.stringify(body),
      { headers: this.headers }
    );
  }

  public getDocumentsCandidate(candidate_id: number) {
    return this.http.get(
      `${this.apiUrl}/documents-candidate?candidate_id=${candidate_id}`,
      { headers: this.headers }
    );
  }
  public getDocumentsCandidateEmployee(candidate_id: number) {
    return this.http.get(
      `${this.apiUrl}/documents-candidate/employee?candidate_id=${candidate_id}`,
      { headers: this.headers }
    );
  }
  public addCandidateUser(body: Object): Observable<Response> {
    return this.http.post(
      `${this.apiUrl}/candidate-synergo`,
      JSON.stringify(body),
      { headers: this.headers }
    );
  }
  public transferCandidate(
    values,
    business_id,
    candidate_id?: number
  ): Observable<Response> {
    const request = {
      values,
      business_id,
      ...(candidate_id !== undefined ? { candidate_id } : {}),
    };
    return this.http.patch(
      `${this.apiUrl}/transfer-candidate`,
      JSON.stringify(request),
      { headers: this.headers }
    );
  }
  public viewAttachment(candidate_id): Observable<Blob> {
    return this.http
      .get(`${this.apiUrl}/documents-by-candidate/${candidate_id}`, {
        responseType: ResponseContentType.Blob,
        headers: this.headers,
      })
      .pipe(map((res: Response) => res.blob()));
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/candidate/candidate.service.ts